import { Api } from "api";

export const getCollaborators: any = async (appId: string) => {
  const res = await Api.get(`/mini_apps/v1/${appId}/collaborators`);
  return res.data;
};

export const addCollaborators: any = async (appId: string, payload: any) => {
  const res = await Api.post(`/mini_apps/v1/${appId}/collaborators`, payload);
  return res.data;
};

export const deleteCollaborators: any = async (appId: string, payload: any) => {
  const res = await Api.delete(`/mini_apps/v1/${appId}/collaborators`, {
    data: payload,
  });
  return res.data;
};

export const findUser: any = async (phone: string) => {
  const res = await Api.get(`/users/v1?phone_number=${phone}`);
  return res.data;
};
